const FromArrEditor = [{
		modelvalue: "",
		title: "年度：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 35,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
		event: 'YearChange'
	},
	{
		modelvalue: "",
		title: "经销商：",
		// inputtype: "input",
		inputtype: "selectSingle",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
		loading: false,
		remoteMethod: 'AuthorizedDealer',
		event: 'AuthorizedDealerChange'
	},
	{
		modelvalue: "",
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 70,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
		event: 'invClassChange'
	},
	{
		title: "指标自动分配：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 326,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 400,
		checked: false,
		disabled: true,
		event: 'OnceYearChange'
	},
	{
		title: "高层审批：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: true,
		marginLeft: 200,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 400,
		checked: false,
	},
	{
		modelValue: undefined,
		title: "年度指标",
		inputtype: "NumberInput",
		desc: '(GTS指标)：',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 0,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 600,
		max: undefined,
		min: 0,
		precision: 0,
		event: 'YearQuotaChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "第一季度指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: -277,
		marginTop: 78,
		displayVal: "inline-block",
		fontWeightVal: 600,
		max: undefined,
		min: 0,
		precision: 0,
		step: 1000,
		event: 'QuarterChange',
	},
	{
		modelValue: undefined,
		title: "一月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		marginLeft: -250,
		marginTop: 132,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		disabled: true,
		min: 0,
		precision: 0,
		event: 'FirstQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "二月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		marginLeft: 50,
		marginTop: 130,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		disabled: true,
		min: 0,
		precision: 0,
		event: 'FirstQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "三月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		marginLeft: 680,
		marginTop: -32,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		disabled: true,
		min: 0,
		precision: 0,
		event: 'FirstQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "第二季度指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 40,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 600,
		max: undefined,
		min: 0,
		precision: 0,
		step: 1000,
		event: 'QuarterChange',
	},
	{
		modelValue: undefined,
		title: "四月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		marginLeft: -250,
		marginTop: 80,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		disabled: true,
		min: 0,
		precision: 0,
		event: 'SecondQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "五月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		marginLeft: 50,
		marginTop: 80,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		disabled: true,
		min: 0,
		precision: 0,
		event: 'SecondQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "六月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 680,
		marginTop: -32,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		min: 0,
		precision: 0,
		event: 'SecondQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "第三季度指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 40,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 600,
		max: undefined,
		min: 0,
		precision: 0,
		step: 1000,
		event: 'QuarterChange',
	},
	{
		modelValue: undefined,
		title: "七月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: -250,
		marginTop: 80,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		min: 0,
		precision: 0,
		event: 'ThirdQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "八月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 50,
		marginTop: 80,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		min: 0,
		precision: 0,
		event: 'ThirdQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "九月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 680,
		marginTop: -32,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		min: 0,
		precision: 0,
		event: 'ThirdQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "第四季度指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 40,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 600,
		max: undefined,
		min: 0,
		precision: 0,
		step: 1000,
		event: 'QuarterChange',
	},
	{
		modelValue: undefined,
		title: "十月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: -250,
		marginTop: 80,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		min: 0,
		precision: 0,
		event: 'FourthQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "十一月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 40,
		marginTop: 80,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		min: 0,
		precision: 0,
		event: 'FourthQuarterChange',
		step: 1000
	},
	{
		modelValue: undefined,
		title: "十二月指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: true,
		marginLeft: 670,
		marginTop: -32,
		displayVal: "inline-block",
		fontWeightVal: 400,
		max: undefined,
		min: 0,
		precision: 0,
		event: 'FourthQuarterChange',
		step: 1000
	},
	{
		modelvalue: "",
		title: "LEVEL1.5：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 2,
		marginTop: -526,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
		event: 'level15Change'
	},
	{
		modelvalue: "",
		title: "申请理由：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 410,
		height: 32,
		disabled: false,
		marginLeft: -220,
		marginTop: 14,
		displayVal: "inline-block",
		fontWeightVal: 400,
		loading: false,
	},
];
export default FromArrEditor;